import React from 'react';
import BrandDetail from '../components/BrandDetail';

const Minimal = () => {
  return <BrandDetail brandSlug="minimal" />;
};

export default Minimal;
